import axios from 'axios';

// Constants
import {
  API_CROWD_LOGIN,
  ARNEO_ECOCONCEPTION_CROWD_TOKEN,
} from '../../constants';

// Components
import Header from '../../blocks/Header';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Checkbox from '../../components/Checkbox';
import { getApiBaseUrl } from '../../utils';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      response: '',
      remember: false,
      submitButton: "C'est parti !",
      form: {
        username: '',
        password: '',
      },
      errors: {
        username: null,
        password: null,
      },
    };
  },
  components: {
    Header,
    Button,
    AtomInput: Input,
    Checkbox,
  },
  computed: {
    hasErrors() {
      if (this.errors.username) {
        return true;
      }

      if (this.errors.password) {
        return true;
      }

      return false;
    },
  },
  methods: {
    async login() {
      if (this.loading) return;

      this.response = null;
      this.loading = true;

      /**
       * Check if all fields are filled
       */
      if (this.form.username && this.form.username.length > 0) {
        this.errors.username = null;
      } else {
        this.errors.username = 'Veuillez renseigner votre identifiant JIRA';
      }

      if (this.form.password && this.form.password.length > 0) {
        this.errors.password = null;
      } else {
        this.errors.password = 'Veuillez renseigner votre mot de passe JIRA';
      }

      if (this.hasErrors) {
        this.loading = false;

        return;
      }

      this.submitButton = 'Connexion en cours';

      // Make API call to login
      try {
        const request = await axios.post(getApiBaseUrl() + API_CROWD_LOGIN, {
          username: this.form.username,
          password: this.form.password,
        });

        if (request && request.data && request.data.token) {
          // Save Token
          localStorage.setItem(
            ARNEO_ECOCONCEPTION_CROWD_TOKEN,
            request.data.token,
          );

          // Set token for socket
          if (this.$socket) {
            this.$socket.client.io.opts.query.accessToken = request.data.token;
          }

          // Redirect user to Audit page
          this.$router.push({ name: 'Audit' });
        }
      } catch (error) {
        throw new Error(error && error.message);
      } finally {
        this.loading = false;
        this.submitButton = "C'est parti !";
      }
    },
  },
};
